
// update heights of images in the carousel
// Ajustement des flèches slick, sauf pour le bloc #primary-images
function updateSlickArrowPosition() {
  $('.slick-active').each(function () {
    var $active = $(this);

    if ($active.closest('#primary-images').length > 0) {
      return; // Ne pas appliquer pour ce bloc
    }

    var $imageContainer = $active.find('.image-container');
    if ($imageContainer.length === 0) return;

    var topPosition = $imageContainer.height() / 2;
    $active.closest('.slick-slider').find('.slick-arrow').css('top', topPosition + 'px');
  });
}

// Slider with carousel slick
$(".carousel-slider").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  adaptiveHeight: true,
  responsive: [{
    breakpoint: 667,
    settings: {
      centerMode: true,
      centerPadding: '0',
      slidesToShow: 2,
      swipe: true,
      dots: false,
    }
  }
  ]
}).on('afterChange', function (event) {
  updateSlickArrowPosition();
}).trigger('afterChange');


var loadedRecomSlot = [];

function deplaceArrows() {
  $('.recently-v-arrows .slick-prev').insertBefore('.title-arrows-rv');
  $('.recently-v-arrows .slick-next').insertAfter('.title-arrows-rv');
  $('.complet-set-arrows .slick-prev').insertBefore('.title-arrows-cs');
  $('.complet-set-arrows .slick-next').insertAfter('.title-arrows-cs');
}

$('.shop-reco .slick-prev').insertBefore('.title-arrows-shop');
$('.shop-reco .slick-next').insertAfter('.title-arrows-shop');

var $sliderPDP = $(".slider-pdp");

if ($sliderPDP.length > 0 && !$sliderPDP.hasClass('slick-initialized')) {
  $(".slider-pdp").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    speed: 0,
    centerPadding: '0',
    infinite: false,
    swipe: false,
    vertical: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          swipe: true,
          infinite: true,
          vertical: false,
          fade: false,
          speed: 500
        }
      },
      {
        breakpoint: 1024, // Option pour les tablettes et plus grands écrans
        settings: {
          dots: true,
          swipe: true,  // Swipe activé sur tablette
          vertical: false, // Pas de défilement vertical
          fade: false,
          speed: 500
        }
      }
    ]
  });
}

if ($(".image-carousel-thumbnails").length > 0) {

  $(document).ready(function () {
    var idVideo = $(".product-detail").data('id-video') || '';
    var vimeoUrl = `https://vimeo.com/${idVideo}`;
    var firstImageUrl = $('.image-carousel-thumbnails .slick-item img').first().attr('src');
    function getImageHeightFromUrl(imageUrl) {
      var urlParams = new URLSearchParams(imageUrl.split('?')[1]);
      var height = urlParams.get('sh'); // Récupère la valeur de 'sh' (hauteur)
      return height ? parseInt(height) : 272;
    }

    $.ajax({
      url: "https://vimeo.com/api/oembed.json",
      type: "GET",
      dataType: "json",
      data: { url: vimeoUrl },
      success: function (data) {
        var thumbnailUrl = data.thumbnail_url_with_play_button;

        $('.image-carousel-thumbnails .slick-slide iframe').each(function () {
          var iframe = $(this);
          var slide = iframe.closest('.slick-slide');

          var image = $('<img>', {
            src: thumbnailUrl,
            class: 'd-block img-fluid img-video',
            alt: 'Video Thumbnail'
          });

          var imageHeight = $('.image-carousel-thumbnails .slick-item').first().height();
          image.css('height', imageHeight + 'px');

          slide.empty();
          slide.append(image);
        });
      },
      error: function (xhr, status, error) {
        console.log("Erreur lors de la récupération des données : " + error);
      }
    });
  });

  var $sliderThumbs = $(".image-carousel-thumbnails");

  if ($sliderThumbs.length > 0 && !$sliderThumbs.hasClass('slick-initialized')) {
    $sliderThumbs.on("init", function (e, slick) {

    }).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerPadding: '0',
      infinite: false,
      vertical: true,
      asNavFor: '.slider-pdp',
      focusOnSelect: true,
      adaptiveHeight: true,
      arrows: true
    });

    $sliderThumbs.on('afterChange', function (event, slick, currentSlide) {
      var currentIndex = $('.slider-pdp').slick('slickCurrentSlide');
      var totalSlides = slick.$slides.length;
      $(".primary-images").attr('current-index-slider', currentIndex);
      if (currentSlide === 0) {
        $('.image-carousel-thumbnails .slick-prev').css('opacity', '0').css('pointer-events', 'none');
      } else {
        $('.image-carousel-thumbnails  .slick-prev').css('opacity', '1').css('pointer-events', 'auto');
      }
      if (currentSlide === totalSlides - 1) {
        $('.image-carousel-thumbnails  .slick-next').css('opacity', '0').css('pointer-events', 'none');
      } else {
        $('.image-carousel-thumbnails  .slick-next').css('opacity', '1').css('pointer-events', 'auto');
      }
      SkpHeightImage();
    });
    function SkpHeightImage() {
      var window_Width = $(window).width();

      if (window_Width > 840) {
        var PDP_Height = $(".image-carousel-thumbnails .slick-list").height();
        $('.primary-images, .primary-images iframe , .primary-images .slick-slide .img-fluid , .slider-pdp .slick-list').css('height', PDP_Height);
        $('.border-pdp-slides').css('height', PDP_Height + 1);
      } else {
        var PDP_width =(1 *(window_Width)),
            PDP_Height = (PDP_width* 1.24);
            $('.product-detail .primary-images .img-fluid,.primary-images,.primary-images iframe, .slider-pdp .slick-list').css('height',PDP_Height);
      }
    }

    $sliderThumbs.on('wheel', function (e) {
      var slickObj = $(this).slick('getSlick');
      var currentSlide = slickObj.currentSlide;
      var totalSlides = slickObj.slideCount;

      if (totalSlides === 3 || totalSlides === 0) {
        return;
      }

      if (currentSlide === totalSlides - 1 && e.originalEvent.deltaY > 0) {
        return;
      }

      if (e.originalEvent.deltaY < 0) {
        if (currentSlide > 0) {
          e.preventDefault();
          $(this).slick('slickPrev');
        }
      }
      else if (e.originalEvent.deltaY > 0) {
        if (currentSlide < totalSlides - 1) {
          e.preventDefault();
          $(this).slick('slickNext');
        }
      }
    });

    $sliderThumbs.on('click', '.slick-next', function () {
      $('.image-carousel-thumbnails .slick-prev').css('opacity', '1');
    });
  }
}

function adjustCarouselImageHeight() {
  var windowWidth = $(window).width();
  var carouselWidth = windowWidth > 840 ? windowWidth / 4 : windowWidth / 2;
  var carouselHeight = carouselWidth * 1.24;

  $('.carousel-slider .product-tile .image-container').css('height', carouselHeight);
}

function skpHeightImage() {
  const $window = $(window);
  var window_Width = $window.width();
  if (window_Width > 840) {
    var PDP_Height = $(".image-carousel-thumbnails-fake").height();
    $('.primary-images, .primary-images iframe , .primary-images .slick-slide .img-fluid , .slider-pdp .slick-list').css('height', PDP_Height);
    $('.border-pdp-slides').css('height', PDP_Height + 1);
  } else {
    var PDP_width =(1 *(window_Width)),
    PDP_Height = (PDP_width* 1.24);
    $('.product-detail .primary-images .img-fluid,.primary-images,.primary-images iframe, .slider-pdp .slick-list').css('height',PDP_Height);
  }
}

// Gestion de l’espace pour le country switcher
function adjustCountrySwitcherPadding() {
  var $switcher = $('.country-switcher-header');
  if ($switcher.length === 0) return;

  var isBannerVisible = getCookie('SKP_ShowBanner') === 'true';
  var switcherHeight = $switcher.outerHeight();

  if (isBannerVisible) {
    $switcher.removeClass('hide-country-switcher-header');
    $('body').css('padding-top', switcherHeight - 2 + 'px');
  } else {
    $switcher.addClass('hide-country-switcher-header');
    $('body').css('padding-top', 0);
  }
}

function slickCurrentSlideChanger() {
  var $trusSlick = $('#js-slick-pdp');
  var $fakeSlick = $('#js-fake-slick');
  var $blockFakeSlickPDP = $('.slider-pdp-fake');
  var $blockPDP = $('.slider-pdp');
  if ($sliderThumbs.length > 0 && $sliderThumbs.hasClass('slick-initialized') && $sliderPDP.length > 0 && $sliderPDP.hasClass('slick-initialized')) {
    $trusSlick.removeClass('d-none');
    $fakeSlick.addClass('d-none');


    $blockPDP.removeClass('d-none');
    $blockFakeSlickPDP.addClass('d-none');


    $sliderThumbs.slick('refresh');
    $sliderPDP.slick('refresh');
  }
}

adjustCarouselImageHeight();

$(window).on('load resize', function () {
  $('.image-carousel-thumbnails .slick-next').css('opacity', 1);
  skpHeightImage();
  slickCurrentSlideChanger();
  updateSlickArrowPosition();
  adjustCarouselImageHeight();
  adjustCountrySwitcherPadding();
});


$('.slider-block').slick({
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerPadding: '0',
  infinite: true,
  arrows: false,
  autoplay: true,
  speed: 1000,
  fade: true,
  swipe: true
});

$(document).ready(function () {
  var WindowWidth = $(window).width();
  var WindowHeight = $(window).outerHeight();
  var hauteur_fenetre = $('header').outerHeight();
  var heightImageSlider = WindowHeight - hauteur_fenetre;
  var videoSliderHeight = $('.slider-caroussel .video-mobile').height();
  if (WindowWidth < 768) {
    $('.slider-caroussel .slick-track').each(function () {
      if ($(this).hasClass('exist-video-mobile')) {
        $(this).find('.common-image-component').css('height', videoSliderHeight);
        $('.experience-tkooples_layouts-SKPSliderBlock').parent().closest('.region').css('height', videoSliderHeight);
      } else {
        $(this).find('.common-image-component').css('height', heightImageSlider);
        $('.experience-tkooples_layouts-SKPSliderBlock').parent().closest('.region').css('height', heightImageSlider);
      }
    });
  }
});